import { memo } from 'react';

import { ComponentContextProps } from '@/components';
import { Flex, ProgressBar, Text } from '@/components/core';

export type ConfidenceBarProps = ComponentContextProps & {
  confidence?: number | null;
  threshold?: number | null;
};

const IConfidenceBar = ({ confidence, threshold, variant }: ConfidenceBarProps) => {
  if (typeof confidence !== 'number') return null;
  const confidencePercent = confidence * 100;

  let thresholdComponent;
  if (typeof threshold === 'number') {
    const thresholdPercent = threshold * 100;
    if (confidence >= threshold) {
      thresholdComponent = (
        <Text slot="description" size="xs">
          is above the <span className="!font-semibold">{thresholdPercent.toFixed(2)}%</span> threshold.
        </Text>
      );
    } else {
      thresholdComponent = (
        <Text slot="description" size="xs">
          is below the <span className="!font-semibold">{thresholdPercent.toFixed(2)}%</span> threshold.
        </Text>
      );
    }
  }

  return (
    <Flex col className="gap-sm p-sm">
      <Flex>
        <Text slot="description">Confidence score</Text>
        <div className="grow" />
        <Text className="font-semibold text-gray-800" slot="description">
          {confidencePercent.toFixed(0)}%
        </Text>
      </Flex>
      <ProgressBar
        props={{ barBackground: { className: 'h-[0.625rem]' }, barOverlay: { className: 'h-[0.625rem]' } }}
        barStyle="striped"
        variant={variant}
        value={confidencePercent}
        maxValue={100}
      />
      {thresholdComponent}
    </Flex>
  );
};

export const ConfidenceBar = memo(IConfidenceBar) as typeof IConfidenceBar;
